<template>
    <div>
        <v-row no-gutters>
            <template v-for="(eviction, index) in evictions">
                <v-col lg="6" md="6" sm="12" :key="index">
                    <screen-eviction
                        class="mx-2"
                        :eviction="eviction"
                        :mode="mode"
                        @exclude="$emit('exclude', $event)"
                    ></screen-eviction>
                </v-col>
            </template>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "screen-evictions-grid",
    mixins: [],
    components: {
        ScreenEviction: () => import("./ScreenEviction"),
    },
    props: {
        evictions: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "print",
        },
    },
    data() {
        return {
            records: [],
        };
    },
    created() {},
};
</script>

<style lang="scss" scoped>
</style>